<template>
    <HeaderPanel />
    <Toast />
    <div class="admin-container">
        <Card class="database-card" style="align-items: center; width: 100%;">
            <template #title>
                <h2 class="text-center">Обложки и баннеры</h2>
            </template>
            <template #content>
                <ThemeImages />
            </template>
        </Card>
    </div>
</template>

<script>
import HeaderPanel from '@/components/HeaderPanel.vue'
import ThemeImages from '@/components/AdminPage/ThemeImages.vue'
import Toast from 'primevue/toast'
import Card from 'primevue/card'

export default {
    name: 'ThemeImagesPage',
    components: { HeaderPanel, ThemeImages, Toast, Card }
}
</script>
